// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D1IrtOAUp0LaBFWuQIOc{margin-inline:20px}`, "",{"version":3,"sources":["webpack://./src/pages/powerDialer/pages/view/ui/PowerDialerContacts/PowerDialerContactsFilter/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,kBAAA","sourcesContent":[".filter {\n  margin-inline: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `D1IrtOAUp0LaBFWuQIOc`
};
export default ___CSS_LOADER_EXPORT___;
